<template>
    <div class="calendarVue">
        <div class="o-main-content-area" v-loading="loading">
            <button class="calendar-arrow" @click="prev()"><i class="fa fa-chevron-left"></i></button>
            <label class="o-inline-datepicker">
                <el-date-picker
                    class="o-inline-datepicker-icon"
                    v-model="now"
                    @change="getByMonth()"
                    type="month"
                    format="MMMM yyyy">
                </el-date-picker>
            </label>
            <button class="calendar-arrow" @click="next()"><i class="fa fa-chevron-right"></i></button>
            <div class="c-responsive-fixwidth">
                <full-calendar
                    ref="calendar"
                    :events="events"
                    :config="config"
                    :header="header"
                    :defaultView="defaultView"
                    @event-selected="eventSelected">
                </full-calendar>
            </div>

            <modal name="calender-details" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
                <div tabindex="-1" role="dialog">
                    <div role="document">
                        <div class="modal-content o-common-modal-content">                        
                            <div class="modal-header text-center">
                                <button @click="closeCalenderDetals()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 class="modal-title">{{this.modal_event.title}}</h1>
                            </div>

                            <div class="modal-body c-common-box-shadow o-modal-body o-modal-body--calender">
                                <form>
                                    <div class="row">
                                        <div class="col-sm-12 o-no-padding o-calender-container">
                                            <div class="col-md-5 o-right-no-padding o-calender-area">
                                                <div class="o-calls-table">
                                                    <div class="o-calender-details-list">
                                                        <ul class="">
                                                            <li><strong>Job No.</strong> <span>#{{this.modal_event.job_number}}</span></li>
                                                            <li><strong>Steward:</strong> <span>{{this.modal_event.steward}}</span></li>
                                                            <li><strong>Dispatched by:</strong> <span>{{this.modal_event.created_by}}</span></li>
                                                            <li><strong>Start Date:</strong> <span>{{getGlobalDate(this.modal_event.job_start)}}</span></li>
                                                            <li><strong>End Date:</strong> <span>{{getGlobalDate(this.modal_event.job_end)}}</span></li>
                                                            <li><strong>Employer:</strong> <span>{{this.modal_event.hiring_organization}}</span></li>
                                                            <li><strong>Employer Contact:</strong> <span>{{ (this.modal_event&&this.modal_event.employer&&this.modal_event.employer.employer_users&&this.modal_event.employer.employer_users.length) ? getEmployerUser(this.modal_event) : 'NA' }}</span></li>
                                                            <li><strong>Payroll:</strong> <span>{{this.modal_event.payroll}}</span></li>
                                                        </ul>
                                                    </div>
                                                    <div class="o-calender-wishlist" v-if="(wishlist_lock || ignorelist_lock) && checkWishAccess(modal_event.job_end)">
                                                        <div v-if="wishlist_lock" class="radio o-custom-radio">
                                                                <label>
                                                                    Wished
                                                                    <input type="radio" name="o5" value="W" v-model="wishStatus" @change="openDisplayWishListNotes()">
                                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                                </label>
                                                            </div>
                                                            <div v-if="ignorelist_lock" class="radio o-custom-radio">
                                                                <label>
                                                                    Ignored
                                                                    <input type="radio" name="o5" value="I" v-model="wishStatus" @change="openDisplayWishListNotes()">
                                                                    <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                                </label>
                                                            </div>
                                                    </div>
                                                    <div class="o-calender-wishlist">
                                                        <a href="javascript: void(0)" @click="viewCalendarCall(modal_event.id)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-yellow">View calls</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-7 o-calender-area">
                                                <div class="custom-row u-common-box-shadow c-radius3">
                                                    <div class="o-calls-table">
                                                        <div class="o-common-head">
                                                            <h5 class="c-common-heading"><i class="fa fa-map-marker" aria-hidden="true"></i> 
                                                                Venue: 
                                                                {{ modal_event.venue && modal_event.venue.addresses && modal_event.venue.addresses.length ?
                                                                    modal_event.venue.name+', '
                                                                + modal_event.venue.addresses[0].address+', '
                                                                + modal_event.venue.addresses[0].municipality+', '
                                                                + modal_event.venue.addresses[0].state_province+', '+modal_event.venue.addresses[0].postcode+', '
                                                                + modal_event.venue.addresses[0].country :''}}
                                                            </h5>
                                                        </div>
                                                        <div class="o-map-conatiner">
                                                            <iframe 
                                                                width="100%"
                                                                height="100%"
                                                                frameborder="0" style="border:0"
                                                                :src="getMapUrl()" allowfullscreen>
                                                            </iframe>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 o-no-padding o-calender-container" style="margin-top: 10px;">
                                            <div class="col-md-12 o-right-no-padding o-calender-area" >
                                                <ul class="o-filter-area make-parent-full-width">
                                                <li v-if="this.modal_event.employer_requests_private==0" class="make-parent-full-width"><strong>Employer Request:</strong> <span v-html="safeJobText(modal_event.employer_requests)"></span></li>
                                                                        
                                                <li v-if="this.modal_event.comment_private==0" class="make-parent-full-width"><strong>Comment:</strong> 
                                                    <span v-html="safeJobText(modal_event.comment)"></span></li>
                                                </ul>  
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 o-no-padding">
                                            <div class="col-md-12">
                                                <h5 class="h2">Documents:</h5>
                                            </div>
                                            <div v-if="modal_event && modal_event.attachments && modal_event.attachments.length>0" class="col-md-12">
                                                <div class="o-notes-toggle-container c-bg-white u-pad-all-15 c-common-box-shadow c-radius3 no-margin-top">
                                                    <ul class="o-documents-container" id="document-ul">
                                                        <li v-for="(attachment, key, index) in modal_event.attachments" :key="index" v-if="attachment.shareable" class="document-exist">
                                                            <div class="col-md-4 o-no-padding o-uploaded-doc">
                                                                <span><i class="fa fa-file-o" aria-hidden="true"></i></span> {{snippet(attachment.filename) }}
                                                            </div>
                                                            <div class="col-md-8 o-no-padding text-right o-uploaded-doc-owner">
                                                                <div class="o-inlineblock o-attachmentdate created-time-width">
                                                                        <i class="fa fa-calendar" aria-hidden="true"></i> {{getDateUtc(attachment.created_at)}} <i class="fa fa-clock-o" aria-hidden="true"></i> {{getTimeUtc(attachment.created_at)}}
                                                                    </div>
                                                                    <div class="o-inlineblock text-right action-icon-doc-width">
                                                                        <h5>
                                                                        Dispatched by: {{ getNoteAuthor(attachment) }} 
                                                                        <a @click="copyDocumentLink(attachment.path)"><i class="fa fa-copy"></i></a>
                                                                        </h5>
                                                                    </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer text-center">
                                <ul class="o-filter-area">
                                    <li v-if="footerAccess()">
                                        <button type="button" @click="goToCalls(modal_event.id)" class="btn c-solid-btn modal-footer-btn-style c-solid-btn--orange" ><i class="fa fa-eye" aria-hidden="true"></i> View Calls</button>
                                    </li>
                                    <li v-if="footerAccess()">
                                        <button type="button" @click="goToPhoneSheet(modal_event.id)" class="btn c-solid-btn modal-footer-btn-style c-solid-btn--orange" ><i class="fa fa-tty" aria-hidden="true"></i> Phone Sheet</button>
                                    </li>
                                    <li v-if="footerAccess()">
                                        <button type="button" @click="goToJobDetails(modal_event.id)" class="btn c-solid-btn modal-footer-btn-style c-solid-btn--orange" ><i class="fa fa-briefcase" aria-hidden="true"></i> Job Details</button>
                                    </li>
                                    <li>
                                        <button @click="closeCalenderDetals()" type="button" class="btn c-common-btn c-common-btn--large c-common-btn--red" data-dismiss="modal" aria-label="Close"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="wish_list_notes" width="50%" height="auto" margin="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
                <div tabindex="-1" role="dialog">
                    <div role="document">
                        <div class="modal-header text-center p-10">
                            <button @click="closeDisplayWishListNotes()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h3 class="modal-title">Notes For Dispatcher</h3>
                        </div>
                        <div class="modal-body o-modal-body">
                            <div class="row px-20">
                                <div class="col-sm-12 o-no-padding o-running-strip p-3">
                                    <textarea v-model="employee_message" data-vv-scope="vacation-add" name="label" class="form-control" rows="4" placeholder="Notes for Dispatcher"></textarea>
                                    <button typ="button" class="mt-20 float-right submit-button" @click="changeStatus()">Submit</button>
                                </div>
                            </div>
                        </div>						
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import moment from 'moment-timezone';
    import dateTimeConvert from '../../timeConvert&Compare';
    import safeJobText from '../../safeJobText.js';   // #2005 — v-html on job free text
    export default {
        mixins: [safeJobText],   // #2005 — safeJobText() for the v-html sinks above
        data() {
            return {
                events: [],
                past_job_type:'',
                future_job_type:'',
                jobAccess:false,
                isPast:true,
                wishlist_lock:false,
                ignorelist_lock:false,
                wishStatus:null,
                wished_id:null,
                defaultView: ['month'],
                now: this.calendarMonth,
                month: 0,
                year: 0,
                modal_event: [],
                hide_empty_days : 0,
                header: {
                    left: '',
                    center: 'title',
                    right: ''
                },
                config: {
                    eventLimit: false, // for all non-agenda views
                    allDayDefault:true,
                    views: {
                        agenda: {
                            eventLimit: 10 // adjust to 6 only for agendaWeek/agendaDay
                        }
                    },
                    gotoDate:moment(this.calendarMonth),
                },
                loading:true,  
                full_address_map:'',
                userData: null,
                userDateFormat: null,
                userTimeFormat: null,
                employee_message: ''
            };
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                userRoleSlug: 'userRoleSlug',
                calendarMonth:'calendarMonth',
                userID: 'userID'
            })
        },

        created() {
            this.now=new Date(this.calendarMonth);
            this.loading=true;
            service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
            }).then(async (client) => {
                this.wishlist_lock=(client.data.result.wishlist_lock==1)? true : false ;
                this.ignorelist_lock=(client.data.result.ignorelist_lock==1)? true : false;
                this.past_job_type=client.data.result.settings['job-type-past'][0];
                this.future_job_type=client.data.result.settings['job-type-future'][0];
                this.hide_empty_days=client.data.result.hide_empty_days;
                this.month = this.now.getMonth() + 1;
                this.year = this.now.getFullYear();
                this.$refs.calendar.fireMethod('gotoDate', this.now);
                await this.fetchCalendarEvents();
            }).catch((err) => {
                console.log(err);
                this.loading=false;
            });
            this.getEmployeeDetails();
        },
        methods: {
            async fetchCalendarEvents() {
                await service.getUrl('/api/v3/job/calendarJobsWeb', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': this.employeeId,
                    'month': this.month,
                    'year': this.year
                }).then((res) => {
                    this.loading=false;
                    this.hide_empty_days = res.data.result.hide_empty_days;
                    var jobs = res.data.result.jobs;
                    for (var i = 0; i < jobs.length; i++) {
                        var job_end = moment(jobs[i].end);
                        var eventBase = {
                            'job_start': moment(jobs[i].start),
                            'job_end': job_end,
                            'title': `${jobs[i].title}`,
                            'id': jobs[i].id,
                            'color': "#" + jobs[i].link_color,
                            'job_number': jobs[i].job_number,
                            'created_by': jobs[i].first_name + " " + jobs[i].last_name,
                            'steward': jobs[i].employee?jobs[i].employee.employable.first_name+" "+jobs[i].employee.employable.last_name:'NA',
                            'hiring_organization': (jobs[i].employer) ? jobs[i].employer.name : 'NA',
                            'payroll': (jobs[i].payroll) ? jobs[i].payroll.name : 'NA',
                            'venue': jobs[i].venue,
                            'employee':jobs[i].employee?jobs[i].employee.employable.first_name + " " + jobs[i].employee.employable.last_name:'',
                            'employer':jobs[i].employer,
                            'employer_user_id':jobs[i].employer_user_id,
                            'seniority':jobs[i].employee?jobs[i].employee.seniority:'',
                            'notes':jobs[i].notes,
                            'employer_requests': jobs[i].employer_requests,
                            'comment':jobs[i].comment,
                            'status':jobs[i].status.name,
                            'employer_requests_private':jobs[i].employer_requests_private,
                            'comment_private':jobs[i].comment_private,
                            'attachments':jobs[i].attachments,
                        };
                        if(this.hide_empty_days == 1 && jobs[i].active_dates && jobs[i].active_dates.length > 0){
                            // Group consecutive call dates into ranges
                            var dates = jobs[i].active_dates;
                            var rangeStart = dates[0];
                            var rangeEnd = dates[0];
                            for (var d = 1; d <= dates.length; d++) {
                                var prev = moment(rangeEnd);
                                var curr = d < dates.length ? dates[d] : null;
                                if (curr && moment(curr).diff(prev, 'days') === 1) {
                                    rangeEnd = curr;
                                } else {
                                    this.events.push(Object.assign({}, eventBase, {
                                        'start': rangeStart,
                                        'end': moment(rangeEnd).add(1, 'days').format('YYYY-MM-DD'),
                                    }));
                                    if (curr) {
                                        rangeStart = curr;
                                        rangeEnd = curr;
                                    }
                                }
                            }
                        }
                        else {
                            var start = moment(jobs[i].start).format('YYYY-MM-DD');
                            var end = moment(jobs[i].end).add(1, 'days').format('YYYY-MM-DD');
                            this.events.push(Object.assign({}, eventBase, {
                                'start': start,
                                'end': end,
                            }));
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                });
            },

            getEmployerUser(modalJob) {
                let employer_user = 'NA';
                for(let i=0;i<modalJob.employer.employer_users.length;i++) {
                    if(modalJob.employer.employer_users[i].user_id == modalJob.employer_user_id) {
                        employer_user = modalJob.employer.employer_users[i].user.first_name + ' ' + modalJob.employer.employer_users[i].user.last_name;
                        break;
                    }
                }
                return employer_user;
            },

            getEmployeeDetails() {
                service.get('employee/' + this.employeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    const response = res.data.result;
                    this.userData = response;
                    this.userDateFormat = this.userData.date_format;
                    this.userTimeFormat = this.userData.time_format;
                }).catch((err) => {
                    console.log(err);
                });
            },
            getMapUrl(){
				return dateTimeConvert.getMapUrl(this.full_address_map);
			},
            getJobAccess(jobId){
                this.jobAccess=false;
                service.get('job/' + jobId +'/checkCalendarAccess', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-id': this.employeeId,
                }).
                then((res) => {
                    this.jobAccess=res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
            },
            // #2019 (FS 16857) — eligibility is decided by the JOB's end date, not by the end of
            // the calendar segment that was clicked. With Hide Empty Days on, a job is drawn as
            // one event per run of consecutive call dates, each with its own `end`; checking
            // `modal_event.end` therefore hid the Wished/Ignored controls on the segments whose
            // last call day had passed while showing them on the later segments of the SAME
            // job — "some have a wish button, some do not" (ia8). `job_end` is the job's end,
            // the same rule the server's own wishlist uses (`jobs.end >= today`).
            checkWishAccess(endDate){
                let now=moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD');
                let end=moment(endDate, 'YYYY-MM-DD');
                return end>=now;
            },
            goToCalls(id){
                this.closeCalenderDetals();
                this.$store.dispatch('setSelectedCallList', 'bulk');
                this.$router.push({
                    path: `/viewCalls/`+ btoa(id)
                });
            },
            goToPhoneSheet(id){
                this.closeCalenderDetals();
                this.$router.push({
                    path: `/phoneSheet/`+ btoa(id)
                });
            },
            goToJobDetails(id){
                this.closeCalenderDetals();
                this.$router.push({
                    path: `/jobDetails/`+ btoa(id)
                });
            },
            viewCallAccess(){
                if(this.userRoleSlug=='employee' && this.isPast){
                    if(this.past_job_type=='all-job'){
                    return true
                    }else if(this.past_job_type=='my-job' && this.jobAccess){
                    return true;
                    }
                    return false;

                }else if(this.userRoleSlug=='employee' && !this.isPast){ 
                    if(this.future_job_type=='all-job'){
                    return true
                    }else if(this.future_job_type=='my-job' && this.jobAccess){
                    return true;
                    }
                    return false;

                }
                return true;
              
            },
            footerAccess(){
                if(this.userRoleSlug=='employee')
                    return false;
                else
                    return true;
            },
            openDisplayWishListNotes() {
                if(this.wishStatus=='W') {
                    this.$modal.show('wish_list_notes');
                }else {
                    this.changeStatus();
                }
            },
            closeDisplayWishListNotes() {
                this.$modal.hide('wish_list_notes');
            },

            changeStatus(){
                if(this.wished_id){
                    let body = {
                        'wishlist_id': this.wished_id,
                        'type': this.wishStatus=='I'?'ignorelist':'wishlist',
                        'employee_id': this.employeeId
                    }
                    if(this.wishStatus == 'W'){
                        body.employee_message = this.employee_message
                    }
                    service.post('employee/changeWishlistStatus', body, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'jobId': this.modal_event.id,
                    }).
                    then((res) => {
                        this.$notify({
                            title: this.$t('success'),
                            type: 'success'
                        });
                        this.closeDisplayWishListNotes();
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                            title: this.$t('error'),
                            message: this.$t('something_went_wrong'),
                            type: 'error'
                        });
                    });
                }else{
                    if(this.wishStatus=='W'){
                    service.post('employee/' + this.employeeId + '/wishlist', {
                        'jobId': this.modal_event.id,
                        'employee_message': this.employee_message
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'jobId': this.modal_event.id,
                    }).
                    then((res) => {
                        this.wished_id = res.data.result.id;
                        this.$notify({
                            title: this.$t('success'),
                            type: 'success'
                        });
                        this.closeDisplayWishListNotes();
                    }).catch((err) => {
                        console.log(err);
                        this.$notify.error({
                            title: this.$t('error'),
                            message: this.$t('something_went_wrong'),
                            type: 'error'
                        });
                    });
                    }else{
                        service.post('employee/' + this.employeeId + '/ignorelist', {
                            'jobId': this.modal_event.id
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'jobId': this.modal_event.id,
                        }).
                        then((res) => {
                            this.wished_id = res.data.result.id;
                            this.$notify({
                                title: this.$t('success'),
                                type: 'success'
                            });
                        }).catch((err) => {
                            console.log(err);
                            this.$notify.error({
                                title: this.$t('error'),
                                message: this.$t('something_went_wrong'),
                                type: 'error'
                            });
                        });
                    }
                }
            },
            snippet(value) {
                if (value.length > 20)
                    return value.slice(0, 20) + '  ...';
                else
                    return value;
            },
            getDateUtc(str) {
                return dateTimeConvert.dateFromUtc(str);
            },
            getTimeUtc(dateTime) {
                return dateTimeConvert.timeFromUtc(dateTime);
            },
            getDate(date){
               return moment(date).format('DD MMM YYYY');
            },
            getEndDate(date){
               var a= moment(date).subtract(1, 'days');
               return a.format('DD MMM YYYY');
            },

            getGlobalDate(date) {
                return dateTimeConvert.localDate(date,this.userDateFormat);
            },

            copyDocumentLink(link){
                var textarea = document.createElement("textarea");
                textarea.textContent = link;
                textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    document.execCommand("copy");  // Security exception may be thrown by some browsers.
                    this.$notify({
                        title: this.$t('success'),
                        message: 'link copied to clipboard.',
                        type: 'success'
                    });
                    setTimeout(()=>{ 
                        window.open(link, '_blank');
                    }, 2000);                        
                } catch (ex) {
                    console.warn("Copy to clipboard failed.", ex);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            },
            getNoteAuthor(note) {
                var getAuthor = JSON.parse(note.activity);
                if (getAuthor.uploader_id == this.userId) {
                    return "Me";
                } else {
                    return getAuthor.uploaded_by;
                }
            },
            viewCalendarCall(id){
              this.$modal.hide("calender-details");
              this.$router.push({
                  path: `/calendarJobCall/`+btoa(id)
              });
            },
            closeCalenderDetals() {
                this.$modal.hide("calender-details");
            },
            scheduleWishlist() {
                this.$store.dispatch('setWishListType', 'calendar');
                this.$router.push({
                    path: `/wishlist/`+btoa(this.employeeId)
                });
            },
            async next() {
                this.loading = true;
                var current = new Date(this.now.getFullYear(), this.now.getMonth() + 1, 1);
                this.now = current;
                this.$store.dispatch('setLastJobCalendarMonth', this.now);
                this.month = this.now.getMonth() + 1;
                this.year = this.now.getFullYear();
                this.events = [];
                await this.fetchCalendarEvents()
                this.$refs.calendar.fireMethod('gotoDate', this.now);
                setTimeout(()=>{ 
                  $(".fc-day-grid-container").removeAttr("style");
                }, 3000);
            },
            async getByMonth() {
                this.loading = true;
                this.$store.dispatch('setLastJobCalendarMonth', this.now);
                this.month = this.now.getMonth() + 1;
                this.year = this.now.getFullYear();
                this.events = [];
                await this.fetchCalendarEvents();
                this.$refs.calendar.fireMethod('gotoDate', this.now);
                setTimeout(()=>{ 
                  $(".fc-day-grid-container").removeAttr("style");
                }, 3000);
            },
            
            async prev() {
                this.loading = true;
                var current = new Date(this.now.getFullYear(), this.now.getMonth() - 1, 1);
                this.now = current;
                this.$store.dispatch('setLastJobCalendarMonth', this.now);
                this.month = this.now.getMonth() + 1;
                this.year = this.now.getFullYear();
                this.events = [];
                await this.fetchCalendarEvents();                
                this.$refs.calendar.fireMethod('gotoDate', this.now);
                setTimeout(()=>{ 
                  $(".fc-day-grid-container").removeAttr("style");
                }, 3000);
            },
            
            checkJob(endDate){
                if (endDate.isBefore(moment(), 'day')) {
                    this.isPast = true;
                } else {
                    this.isPast = false;
                }
            },
            eventSelected(event, jsEvent, view) {
                this.modal_event = event;
                let venue = event.venue;
                if(venue && venue.addresses && venue.addresses.length){
                    this.full_address_map = venue.name + ", " +venue.addresses[0].address + ", " +venue.addresses[0].municipality +", "+venue.addresses[0].postcode +", " +venue.addresses[0].state_province +", "+ venue.addresses[0].country;
                }

                this.$modal.show("calender-details");
                this.checkJob(this.modal_event.end);
                this.getJobAccess(this.modal_event.id);
                service.post('job/getWishlistStatus', 
                {
                  job_id: this.modal_event.id,
                  employee_id: this.employeeId
                },
                {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                  if (res.data.result) {
                    this.wishStatus=res.data.result.list_type;
                    this.wished_id=res.data.result.id;
                  }else{
                    this.wishStatus=null;
                    this.wished_id=null;
                  }
                }).catch((err) => {
                    console.log(err);
                });
            },
        },
        mounted() {
          setTimeout(()=>{ 
            $(".fc-day-grid-container").removeAttr("style");
          }, 2000);
        }
    }
</script>

<style>
    @import 'fullcalendar/dist/fullcalendar.css';
    .make-parent-full-width{
      width:100%;
    }

    .modal-footer-btn-style{
      padding: 10px 10px;
    }
    .submit-button {
        margin: 15px 10px 10px 0;
        padding: 10px 20px;
        border: none;
        outline: none;
        background-color: #258325;
        color: #ffffff;
        font-size:13px;
        font-weight: bold;
        border-radius: 5px;
    }
    .p-10 {
        padding: 10px;
    }
    .mt-20 {
        margin-top: 20px;
    }
    .float-right {
        float: right;
    }
    .mt-30 {
        margin-top: 30px;
    }
</style>